import { ReactNode, createContext, useContext } from 'react';
import { FeaturesReady } from '@growthbook/growthbook-react';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import useNewUiScope, { NewUiScope } from '@/data/hook/shared/useNewUiScope';
import LoadingView from '@/pages/courses/LoadingView';
import { GROWTHBOOK_TIMEOUT } from '@/constants';

type UiVersionSwitcherProps = {
  scope: NewUiScope;
  children: ReactNode;
};

type UiVersionSlotProps = {
  children: ReactNode;
};

const UiVersionContext = createContext(false);

function UiVersionSwitcherRoot({ scope, children }: UiVersionSwitcherProps) {
  const isModern = useNewUiScope(scope);
  return (
    <FeaturesReady timeout={GROWTHBOOK_TIMEOUT} fallback={<LoadingView />}>
      <UiVersionContext.Provider value={isModern}>
        {children}
      </UiVersionContext.Provider>
    </FeaturesReady>
  );
}

function Legacy({ children }: UiVersionSlotProps) {
  const isModern = useContext(UiVersionContext);
  return (
    <ConditionalRenderer condition={!isModern}>{children}</ConditionalRenderer>
  );
}

function Modern({ children }: UiVersionSlotProps) {
  const isModern = useContext(UiVersionContext);
  return (
    <ConditionalRenderer condition={isModern}>{children}</ConditionalRenderer>
  );
}

const UiVersionSwitcher = Object.assign(UiVersionSwitcherRoot, {
  Legacy,
  Modern,
});

export default UiVersionSwitcher;
